import { render } from "./MemoryCardGame.vue?vue&type=template&id=5513237c&scoped=true"
import script from "./MemoryCardGame.vue?vue&type=script&lang=js"
export * from "./MemoryCardGame.vue?vue&type=script&lang=js"

import "./MemoryCardGame.vue?vue&type=style&index=0&id=5513237c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5513237c"]])

export default __exports__